import * as ScrollArea from '@radix-ui/react-scroll-area';
import type { PropsWithChildren } from 'react';

import { cn } from '~/lib/cn';

import type { RadixUiProps } from './types';

interface ScrollbarsProps extends RadixUiProps, PropsWithChildren {}

const SCROLLBAR_BG_CLASS = cn(
  'group select-none opacity-stronger',
  'bg-level-03 hover:bg-emphasis-strong',
  'min-h-[0.75rem] min-w-[0.75rem] p-[0.2rem] hover:min-w-[1rem] hover:p-[0.25rem]',
  'transition-[min-width,min-height,padding,background] duration-300',
);

const SCROLLBAR_THUMB_CLASS = cn(
  'rounded-full transition-colors duration-300 bg-default-inverse/stronger group-hover:bg-default-inverse',
);

export function Scrollbars({ children, radix = {} }: ScrollbarsProps) {
  return (
    <ScrollArea.Root
      {...radix.scrollArea}
      className={cn('overflow-hidden', radix.scrollArea?.className)}
    >
      <ScrollArea.Viewport
        {...radix.scrollAreaViewport}
        className={cn(
          'max-h-radix-scroll',
          radix.scrollAreaViewport?.className,
        )}
      >
        {children}
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar
        {...radix.scrollAreaScrollbar}
        orientation="vertical"
        className={cn(SCROLLBAR_BG_CLASS, radix.scrollAreaScrollbar?.className)}
      >
        <ScrollArea.Thumb
          {...radix.scrollAreaThumb}
          className={cn(
            SCROLLBAR_THUMB_CLASS,
            radix.scrollAreaThumb?.className,
          )}
        />
      </ScrollArea.Scrollbar>
      <ScrollArea.Scrollbar
        {...radix.scrollAreaScrollbar}
        orientation="horizontal"
        className={cn(SCROLLBAR_BG_CLASS, radix.scrollAreaScrollbar?.className)}
      >
        <ScrollArea.Thumb
          {...radix.scrollAreaThumb}
          className={cn(
            SCROLLBAR_THUMB_CLASS,
            radix.scrollAreaThumb?.className,
          )}
        />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  );
}

Scrollbars.displayName = 'Scrollbars';
